import { render, staticRenderFns } from "./WebhookRegistersTable.vue?vue&type=template&id=62b10d3f&scoped=true&"
import script from "./WebhookRegistersTable.vue?vue&type=script&lang=js&"
export * from "./WebhookRegistersTable.vue?vue&type=script&lang=js&"
import style0 from "./WebhookRegistersTable.vue?vue&type=style&index=0&id=62b10d3f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b10d3f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VSpacer,VToolbar,VToolbarTitle,VTooltip})
